import { useEffect, useState } from "react";
import { useGetAuftragFilesMutation, useRemoveAuftragFileMutation } from '../api/AuftragAPI';
import { IFilesFromAuftrag } from "../pages/auftrag/AuftragDetails";
import { downloadFile, upload } from "../services/All";
import { formatToEuroDateTime } from '../util/DateUtils';
import styles from './component.module.scss';

type UploadFilesParameter = {
  uid: string
}

const UploadToServer: React.FC<UploadFilesParameter> = ({ uid }) => {

  const [dateienVonAuftrag, setDateienVonAuftrag] = useState<IFilesFromAuftrag>();
  const [getAuftragDateien] = useGetAuftragFilesMutation();
  const [removeAuftragFileAPI] = useRemoveAuftragFileMutation();

  const handleDownload = async (uid: string) => {
    try {

      downloadFile(uid)
        .then((resp) => {
          const contentDisposition = resp?.headers["content-disposition"] || resp?.headers["Content-Disposition"];
          const contentType = resp?.headers["content-type"] || resp?.headers["Content-Type"];

          let filename = "filename";
          let extractedFileName = filename;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) {
              extractedFileName = match[1];
            }
          }

          const blob = new Blob([resp.data], { type: contentType });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = extractedFileName;
          link.click();
          link.remove();
        });
    } catch (error) {
      console.error("Download-Fehler:", error);
    }
  };

  const handleRemove = async (fileuid: string) => {
    try {
      removeAuftragFileAPI({auftragUid: uid, fileUid: fileuid}).unwrap()
        .then(() => {
          getAuftragDateien(uid).unwrap().then((data) => setDateienVonAuftrag(data));
        });
    } catch (error) {
      console.error("Remove-Fehler:", error);
    }
  };

  const uploadFile = (files: File[]) => {
    files.forEach(file => {
      upload(uid, file)
        .then(() => {
          getAuftragDateien(uid).unwrap().then((data) => setDateienVonAuftrag(data));
        })
        .catch(error => console.log(error));
    });
  }

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (event.dataTransfer.files) {
      uploadFile(Array.from(event.dataTransfer.files));
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      uploadFile(Array.from(event.target.files));
    }
  };

  useEffect(() => {
    if (!uid) return;
    getAuftragDateien(uid).unwrap().then((data) => setDateienVonAuftrag(data));
  }, [uid]);

  return (
    <div>

      <div className="p-4 border-2 border-dashed rounded-lg w-96">
        <div
          className="p-6 text-center bg-gray-100 rounded-md cursor-pointer"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <p>Ziehe deine Dateien zum Upload hierher oder</p>
          <label className="text-blue-500 underline cursor-pointer">
            Durchsuchen
            <input type="file" multiple className="hidden" onChange={handleFileChange} />
          </label>
        </div>
      </div>

      {dateienVonAuftrag?.files.map((e, index) =>
        <div key={index} className={styles["auftragCard"]} >

          {/*<div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', columnGap: "10px" }}>

            <div>
              <img src={`data:image/png;base64, ${e.data}`} width={100} />
            </div>
            <div>

              <p style={{ fontSize: "10pt" }}>{e.filename}</p>
              <p>
                Erstellt am: {formatToStringISODate(e.createDateTime)}
              </p>
              <p>
                <button className="btn btn-primary" onClick={() => { handleDownload(e.uid) }}><i className="bi bi-cloud-arrow-down-fill" />&nbsp;Download</button>
              </p>
            </div>

          </div>*/}

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', columnGap: "10px" }}>
            <div>{e.filename}</div>
            <div>{formatToEuroDateTime(e.createDateTime)}</div>
            <div style={{ textAlign: "right" }}>
              <p>
                <button className="btn btn-danger" onClick={() => { handleRemove(e.uid) }}><i className="bi bi-trash" />&nbsp;Entfernen</button>
              
                <button className="btn btn-primary" onClick={() => { handleDownload(e.uid) }}><i className="bi bi-cloud-arrow-down-fill" />&nbsp;Download</button>
              </p>
            </div>
          </div>

        </div>
      )}

      {/*<div className="card">
        <FileUpload name="demoFileUpload"
          url={process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + 'imageUpload'}
          multiple
          accept="image/*"
          maxFileSize={5000000}
          emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>}
          customUpload
          auto={true}
          uploadHandler={async (event) => {
            const filelist = event.files;
            if (filelist !== undefined && filelist !== null) {
              uploadFile(filelist[0]);
            }
            event.options.clear();
          }}
        />
      </div>*/}
    </div>

  )
}

export default UploadToServer;